import {createGlobalStyle} from "styled-components";

export const Global = createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    transition: background-color 0.3s ease-in-out;
  }
  
  body {
    background: ${({theme}) => theme.colors.background};
    font-family: ${({theme}) => theme.fonts.primary};
    color: ${({theme}) => theme.colors.text};
    transition: background 0.5s;
  }
`;